/*
 * Configs can change later on.
 */
export const AVAILABLE_LOCALE = {
  en: {
    label: 'English',
    localizationSlug: 'ENGLISH',
    value: 'en',
    translationListUrl: `${CDN_URL}/localization/en-us.json`,
  },
  th: {
    label: 'Thai',
    localizationSlug: 'THAI',
    value: 'th',
    translationListUrl: `${CDN_URL}/localization/th-th.json`,
  },
  enTh: {
    label: 'Thai English',
    localizationSlug: 'ENGLISH',
    value: 'en-th',
    translationListUrl: `${CDN_URL}/localization/en-th.json`,
  },
};

export const LOCALE_WHITELIST = ['en', 'th', 'enTh'];
export const THAI_WHITELIST = ['th', 'enTh'];
export const US_WHITELIST = ['en', 'th'];
